import {
  CREATE_OCCUPANCY,
  CREATE_OCCUPANCY_SUCCESS, DELETE_OCCUPANCY,
  GET_ALL_OCCUPANCY_LIST,
  GET_ALL_OCCUPANCY_LIST_SUCCESS, GET_OCCUPANCY_BY_ID,
  GET_OCCUPANCY_BY_ID_SUCCESS, UPDATE_OCCUPANCY,
  UPDATE_OCCUPANCY_SUCCESS,
  GET_OCCUPANCY_MODE_OPTIONS,
  GET_OCCUPANCY_MODE_OPTIONS_SUCCESS
} from '../storeTypes';

const INIT_STATE = {
  loader: false,
  occupancyList: [],
  occupancyDetails: null,
  occupancyOptions: [],
};

function OccupancyReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case GET_ALL_OCCUPANCY_LIST: {
      return {
        ...state,
        occupancyList: [],
        loader: true,
      };
    }

    case GET_ALL_OCCUPANCY_LIST_SUCCESS: {
      return {
        ...state,
        loader: false,
        occupancyList: action.payload,
      };
    }

    case CREATE_OCCUPANCY: {
      return {
        ...state,
        loader: true,
      };
    }
    case CREATE_OCCUPANCY_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }
    case UPDATE_OCCUPANCY: {
      return {
        ...state,
        loader: true,
      };
    }
    case UPDATE_OCCUPANCY_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }
    case GET_OCCUPANCY_BY_ID: {
      return {
        ...state,
        occupancyDetails: null,
        loader: true,
      };
    }
    case GET_OCCUPANCY_BY_ID_SUCCESS: {
      return {
        ...state,
        loader: false,
        occupancyDetails: action.payload,
      };
    }
    case DELETE_OCCUPANCY: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_OCCUPANCY_MODE_OPTIONS: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_OCCUPANCY_MODE_OPTIONS_SUCCESS: {
      return {
        ...state,
        loader: false,
        occupancyOptions: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}

export default OccupancyReducer;